// alterado - revisado

import React from 'react'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import RiscosFormHistoricoSaudeRiscos from './RiscosFormHistoricoSaudeRiscos'

const RiscosForm = ({ values, handleChange, handleSubmit, handleSubmitAutomatico }) => {
    return (
        <ValidatorFormPadrao 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <RiscosFormHistoricoSaudeRiscos
                values={values}
                handleChange={handleChange}
                handleSubmitAutomatico={handleSubmitAutomatico}
            />
        </ValidatorFormPadrao>
    )
}

export default RiscosForm